"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var serialOperation_1 = require("./serialOperation");
var es6_promise_1 = require("es6-promise");
function buildSetWindowLocationHrefCallback(startSerialOperation) {
    return function setWindowLocationHref(url) {
        startSerialOperation(function () {
            window.location.href = url;
            /* this promise never resolves because we're leaving the page */
            return new es6_promise_1.Promise(function (resolve) { });
        }, serialOperation_1.FeedbackType.LoadingBannerImmediate);
    };
}
exports.buildSetWindowLocationHrefCallback = buildSetWindowLocationHrefCallback;
